import ModalForm from "../../../components/base/forms/modal-form";
import Api from "../../../lib/api";
import ServiceLocator from "../../../global/service-locator";
import {AnalyticsService} from "../../../services/analytics-service";

export default class PaidEventConsultationForm {
	constructor() {
		this.$root = document.getElementById('modal-paid-event-consultation');
		this.$triggers = document.querySelectorAll(
			'[data-modal-trigger="paid-event-consultation"]');

		this.sl = ServiceLocator.instance;

		this.form = null;

		if (this.$root && this.$triggers.length) {
			this.init();
		}
	}

	init() {
		this.form = new ModalForm({
			formId: 'paid-event-consultation',
			uri: '/1.0/blog/event/paid-registration',
			data: {
				fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
				fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
				referrer: location.href,
				city: Api.currentCityId,
				eventId: craft.page.entryId,
				source: 'consultation'
			},
			$modalTriggers: Array.from(this.$triggers),
			hash: 'event-consultation',
			showResult: true,
			subscriptions: [
				{
					// Update custom fields data to format { label, value }
					event: 'beforeSubmit',
					callback: ({ detail }) => {
						const updatedData = {};

						if (this.sl.userDataService.lmsUserData) {
							Object.assign(updatedData, { lmsUserId: this.sl.userDataService.lmsUserData._id });
						}

						this.form.addData(updatedData);

						const dataLayerEventData = {
							event: 'paid_event_consultation',
							formId: this.form.formId,
							phone: this.form.data.tel,
							email: this.form.data.email
						};

						const $formTitle = this.form.$root.querySelector('.form_title');

						if ($formTitle) {
							dataLayerEventData.formName = $formTitle.textContent;
						}

						AnalyticsService.sendEvent('paid_event_consultation', dataLayerEventData);
					}
				}
			]
		});
	}
}